import {
  FrameworkMin,
  FrameworkId,
  FrameworkVersionMin,
  CreateFrameworkVersion,
  CreateFramework,
  OwnerId,
  PresetFramework,
  PresetFrameworkVersion,
} from "platformed-client/types";
import {invalidateQueries, q} from "../../state";
import {platformedClient} from "..";

export async function list(): Promise<FrameworkMin[]> {
  return platformedClient.internalRequest("get", "/region/{region}/api/tprm/frameworks", {});
}

export async function get(frameworkId: FrameworkId): Promise<FrameworkMin> {
  return platformedClient.internalRequest("get", "/region/{region}/api/tprm/frameworks/{framework_id}", {
    path: {framework_id: frameworkId},
  });
}

export async function create(framework: CreateFramework): Promise<string> {
  const res = await platformedClient.internalRequest("post", "/region/{region}/api/tprm/frameworks", {body: framework});
  await invalidateQueries([q.tprm.frameworks.filter()]);
  return res;
}

export async function delete_(frameworkId: FrameworkId): Promise<string> {
  const res = await platformedClient.internalRequest("delete", "/region/{region}/api/tprm/frameworks/{framework_id}", {
    path: {framework_id: frameworkId},
  });
  await invalidateQueries([q.tprm.frameworks.filter()]);
  await invalidateQueries([q.tprm.frameworkVersions.filter()]);
  return res;
}

export async function createVersion(frameworkId: FrameworkId, version: CreateFrameworkVersion): Promise<string> {
  const res = await platformedClient.internalRequest(
    "post",
    "/region/{region}/api/tprm/frameworks/{framework_id}/versions",
    {path: {framework_id: frameworkId}, body: version},
  );
  await invalidateQueries([q.tprm.framework.filter(frameworkId)]);
  await invalidateQueries([q.tprm.frameworkVersions.filter()]);
  return res;
}

export async function createVersionFromPreset(
  frameworkId: FrameworkId,
  preset: PresetFrameworkVersion,
): Promise<string> {
  const res = await platformedClient.internalRequest(
    "post",
    "/region/{region}/api/tprm/frameworks/{framework_id}/create_from_preset",
    {path: {framework_id: frameworkId}, body: preset},
  );
  await invalidateQueries([q.tprm.framework.filter(frameworkId)]);
  await invalidateQueries([q.tprm.frameworkVersions.filter()]);
  return res;
}

export async function listVersions(frameworkId: FrameworkId): Promise<FrameworkVersionMin[]> {
  return platformedClient.internalRequest("get", "/region/{region}/api/tprm/frameworks/{framework_id}/versions", {
    path: {framework_id: frameworkId},
  });
}

export async function getLatest(frameworkId: FrameworkId): Promise<FrameworkVersionMin> {
  return platformedClient.internalRequest("get", "/region/{region}/api/tprm/frameworks/{framework_id}/latest", {
    path: {framework_id: frameworkId},
  });
}

export async function updateName(frameworkId: FrameworkId, name: string): Promise<string> {
  const res = await platformedClient.internalRequest(
    "post",
    "/region/{region}/api/tprm/frameworks/{framework_id}/name",
    {path: {framework_id: frameworkId}, body: name},
  );
  await invalidateQueries([q.tprm.framework.filter(frameworkId)]);
  return res;
}

export async function createFromPreset(preset: PresetFramework): Promise<string> {
  const res = await platformedClient.internalRequest(
    "post",
    "/region/{region}/api/tprm/frameworks/create_from_preset",
    {body: preset},
  );
  await invalidateQueries([q.tprm.frameworks.filter()]);
  return res;
}

export async function assign(frameworkId: FrameworkId, owner: OwnerId | null): Promise<string> {
  const res = await platformedClient.internalRequest(
    "post",
    "/region/{region}/api/tprm/frameworks/{framework_id}/owner",
    {path: {framework_id: frameworkId}, body: owner},
  );
  await invalidateQueries([q.tprm.frameworks.filter(), q.tprm.framework.filter(), q.tprm.frameworkVersions.filter()]);
  return res;
}
